import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import EventType from "src/containers/EventType"
import EventTypeItem from "src/containers/EventType/Item"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  EVENT_TYPES_URL,
  EVENT_TYPES_ID_URL,
  DEFAULT_ID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

export default (
  <Route path={EVENT_TYPES_URL}>
    <BaseLayout title="Типы ресурсов">
      <Switch>
        <Route path={EVENT_TYPES_URL} exact component={EventType} />
        <Route
          path={EVENT_TYPES_ID_URL}
          exact
          component={withRouteValidation({
            routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
          })(EventTypeItem)}
        />
      </Switch>
    </BaseLayout>
  </Route>
)
